import cogoToast from 'cogo-toast';
import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import apiCall from '../../apiCall.js';

import { POST_STATIC_COUPON, POST_STATIC_COUPON_SUCCESS, POST_STATIC_COUPON_ERROR } from './../../actionType.js';

function* postStaticCoupon({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/static-coupon`,
      method: 'POST',
      data: payload.data,
      isFormData: true,
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: POST_STATIC_COUPON_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: POST_STATIC_COUPON_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: POST_STATIC_COUPON_ERROR, payload: error });
  }
}

export function* watchStaticPostCoupon() {
  yield takeEvery(POST_STATIC_COUPON, postStaticCoupon);
}

function* postStaticCouponSaga() {
  yield all([fork(watchStaticPostCoupon)]);
}

export default postStaticCouponSaga;
